module.exports = __webpack_public_path__ + "img/league_new_next.1e9f3491.svg";